module.exports = __webpack_public_path__ + "img/no-result.b480a8a9.svg";